import { AppBundle } from 'api/optimalprint-sdk.d';
import cn from 'classnames';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import styles from 'components/StudioSearchPage/StudioSearchResults/ItemsFilter/CheckBoxOptions/CheckBoxOptions.module.scss';
import React from 'react';
import { useDispatch } from 'react-redux';
import { FilterAttributeGroup } from 'store/category/types';
import updateFilterAttributeOptionOperation from 'store/studioSearch/operation/updateFilterAttributeOptionOperation';
import CheckMark from 'components/SearchPage/SearchFilters/CheckMark';

export interface OwnProps {
  attribute: AppBundle.Api.Response.Category.V3.CategoryDesignsListV3Response.Filters.IFilterItem;
  group: FilterAttributeGroup;
  applyFilterCallback: () => void;
}

const CheckBoxOptions = ({ attribute, group, applyFilterCallback }: OwnProps) => {
  const dispatch = useDispatch();
  const setFilterOption = async (value: string) => {
    await dispatch(updateFilterAttributeOptionOperation(group, attribute.typeName, value));
    applyFilterCallback();
  };

  return (
    <div className={styles.checkBoxOptions}>
      {attribute.options?.map((option) => (
        <div
          key={option.value}
          className={cn(styles.option, {
            [styles.available]: option.isAvailable,
          })}
          onClick={() => setFilterOption(option.value)}
        >
          <div className={styles.checkmark}>
            <CheckMark checked={option.isSelected} />
          </div>
          <OpText variant="body" size="large" className={styles.checkboxText}>
            {option.name}
          </OpText>
        </div>
      ))}
    </div>
  );
};

export default CheckBoxOptions;
